import { template } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import ENV from 'client-portal/config/environment';
import styles from './pagination.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchPagination extends Component {
    styles = styles;
    get totalPages() {
        return +this.args.meta?.totalPages || 0;
    }
    get showPagination() {
        return this.totalPages > 1;
    }
    get pageNumber() {
        return +this.args.meta?.page?.number || 1;
    }
    get maxWindowStart() {
        let total1 = this.totalPages;
        if (!total1) {
            return 1;
        }
        return Math.max(1, total1 - (ENV.clinicianSearchPaginationWindowSize - 1));
    }
    get windowStart() {
        let total1 = this.totalPages;
        let currentPage1 = this.pageNumber;
        if (!total1 || total1 <= ENV.clinicianSearchPaginationWindowSize) {
            return 1;
        }
        let maxStart1 = this.maxWindowStart;
        let fromPage1 = (Math.ceil(currentPage1 / ENV.clinicianSearchPaginationWindowSize) - 1) * ENV.clinicianSearchPaginationWindowSize + 1;
        return Math.min(Math.max(1, fromPage1), maxStart1);
    }
    get visiblePages() {
        let total1 = this.totalPages;
        if (!total1) {
            return [];
        }
        let start1 = this.windowStart;
        let end1 = Math.min(start1 + ENV.clinicianSearchPaginationWindowSize - 1, total1);
        let pages1 = [];
        for(let p1 = start1; p1 <= end1; p1++){
            pages1.push(p1);
        }
        return pages1;
    }
    get showChevrons() {
        return this.totalPages > ENV.clinicianSearchPaginationWindowSize;
    }
    get showLeftChevron() {
        return this.showChevrons && this.windowStart > 1;
    }
    get showRightChevron() {
        return this.showChevrons && this.windowStart < this.maxWindowStart;
    }
    pageButtonClass = (pageNum1)=>{
        return pageNum1 === this.pageNumber ? 'page-button is-current' : 'page-button';
    };
    selectPage = (pageNum1, event1)=>{
        event1?.preventDefault?.();
        if (pageNum1 === this.pageNumber) {
            return;
        }
        this.args.onPageChange?.(pageNum1);
    };
    slideRight = (event1)=>{
        event1?.preventDefault?.();
        if (!this.showRightChevron) {
            return;
        }
        let nextStart1 = this.windowStart + ENV.clinicianSearchPaginationWindowSize;
        this.args.onPageChange?.(nextStart1);
    };
    slideLeft = (event1)=>{
        event1?.preventDefault?.();
        if (!this.showLeftChevron) {
            return;
        }
        let prevStart1 = Math.max(1, this.windowStart - ENV.clinicianSearchPaginationWindowSize);
        let lastInWindow1 = Math.min(prevStart1 + ENV.clinicianSearchPaginationWindowSize - 1, this.totalPages);
        this.args.onPageChange?.(lastInWindow1);
    };
    static{
        template(`
    {{#if this.showPagination}}
      <nav
        class={{styles.component}}
        aria-label={{t "booking.clinicianSearch.pagination.navLabel"}}
        data-test-clinician-pagination
      >
        {{#if this.showLeftChevron}}
          <button
            type="button"
            class="chevron-button"
            aria-label={{t "booking.clinicianSearch.pagination.slidePreviousPages"}}
            {{on "click" this.slideLeft}}
            data-test-clinician-pagination-slide-left
          >
            {{svgJar "chevron-left" class="icon" aria-hidden="true"}}
          </button>
        {{/if}}

        {{#each this.visiblePages as |page|}}
          <button
            type="button"
            class={{this.pageButtonClass page}}
            aria-label={{t "booking.clinicianSearch.pagination.pageNumberAria" page=page}}
            {{on "click" (fn this.selectPage page)}}
            data-test-clinician-pagination-page={{page}}
          >
            {{page}}
          </button>
        {{/each}}

        {{#if this.showRightChevron}}
          <button
            type="button"
            class="chevron-button"
            aria-label={{t "booking.clinicianSearch.pagination.slideNextPages"}}
            {{on "click" this.slideRight}}
            data-test-clinician-pagination-slide-right
          >
            {{svgJar "chevron-right" class="icon" aria-hidden="true"}}
          </button>
        {{/if}}
      </nav>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
